export default __webpack_public_path__ + "static/media/banner-dispatcher.b5a6f066.png";